import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { assetUrl } from '@sparta.targeted-content.helpers/targeted-content-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"login-box-container\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"loginModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"show-for-large-up login-container\">\r\n          <div class=\"login-positioning-container\">\r\n            <section class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "-wrapper "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "-wrapper--med-up\">\r\n              <div class=\"oca-widget-wrapper\">\r\n                <div id=\"ocaContainer\">\r\n                  <div class=\"spinner-container\">\r\n                    <div class=\"spinner-icon rotating\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </section>\r\n          </div>\r\n        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row small-collapse\">\r\n  <div class=\"column small-12\">\r\n    <div class=\"ada-hidden\">\r\n      <h1 id=\"skip-to-h1\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0))
    + "</h1>\r\n    </div>\r\n    <div class=\"hero-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLoginWidget")),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":11,"column":17}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"hero-top-container\">\r\n        <div class=\"hero-image-container\">\r\n          <img class=\"hide-for-medium-up\" src=\""
    + container.escapeExpression((lookupProperty(helpers,"assetUrl")||(depth0 && lookupProperty(depth0,"assetUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"mobileImage") : stack1),{"name":"assetUrl","hash":{},"data":data,"loc":{"start":{"line":15,"column":47},"end":{"line":15,"column":76}}}))
    + "\" alt=\"\"/>\r\n          <img class=\"show-for-medium-up\" src=\""
    + container.escapeExpression((lookupProperty(helpers,"assetUrl")||(depth0 && lookupProperty(depth0,"assetUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"desktopImage") : stack1),{"name":"assetUrl","hash":{},"data":data,"loc":{"start":{"line":16,"column":47},"end":{"line":16,"column":77}}}))
    + "\" alt=\"\"/>\r\n        </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLoginWidget")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":34,"column":15}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n      <div class=\"hero-text-container\">\r\n        <div class=\"content\">\r\n          <h2 class=\"heading\">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0))
    + "\r\n          </h2>\r\n          <p class=\"sub-heading show-for-large-up\">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"sub-heading") : stack1), depth0))
    + "\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.merrill-homepage.modules/merrill-hero-module",
  "version": "3.0.4",
  "id": "merrillHeroModule",
  "containerID": "merrillHomepageMerrillHeroModule",
  "moduleName": "merrill-homepage-merrill-hero-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "merrill-hero-module",
  "data": {
    "init": "MerrillHeroModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "hasLoginWidget",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter determines which login container to display"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        picture,
        assetUrl
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    picture,
    assetUrl
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.sparta-home.utilities/style-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.targeted-content.helpers/targeted-content-helper": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class MerrillHeroModule
 * @extends {Module}
 */
class MerrillHeroModule extends Module {
  /**
   * Creates an instance of MerrillHeroModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    let {
      hostname
    } = spaParams.siteParams.domain;
    hostname = hostname.endsWith('/') ? hostname.slice(0, -1) : hostname;
    this.widgetConfig = {
      widgetName: 'ml-ah-omni-channel-auth-widget',
      widgetVersion: '1.0.0',
      ContainerId: 'ocaContainer',
      language: 'en',
      widgetEventName: 'AH_SIGNIN_FIRST_FACTOR_INITIALIZE',
      payload: {
        autoConfKey: 'MRLLSOPTNV2',
        domain: hostname,
        wogw: true
      }
    };
  }

  /**
  * @returns {void}
  */
  init() {
    this.Events.pub('SECURE_AH_V5_WIDGET_LOADER', this.widgetConfig);
    this.Events.sub('SPARTA_AH_V5_WIDGET_LOADER_READY', event => {
      const widgetEventInstance = event.data.widgetLoader;
      widgetEventInstance.sub('WIDGET_SUBSCRIBE_EVENT_NAME', widgetEvent => {
        console.log(widgetEvent.detail);
      });
    });
  }
}
registerModuleClass({
  moduleClass: MerrillHeroModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { MerrillHeroModule as default, moduleConfig };
